import { AxiosError, AxiosResponse } from "axios";
import { processUnexpectedError } from "./errors";

export const apiCallWithResponse = (
  apiCall: () => Promise<AxiosResponse>,
  successCallback?: (response: AxiosResponse) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall()
    .then((response) => {
      if (successCallback) {
        successCallback(response);
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      } else {
        processUnexpectedError(error);
      }
    });
};

export const apiCall = <T>(
  apiCall: () => Promise<AxiosResponse<T>>,
  successCallback?: (t: T) => void,
  errorCallback?: (error: AxiosError) => void
) => {
  apiCall()
    .then((response) => {
      if (successCallback) {
        successCallback(response.data);
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      } else {
        processUnexpectedError(error);
      }
    });
};

export const apiCallAsync = async <T>(
  apiCall: () => Promise<AxiosResponse<T>>,
  errorCallback?: (error: Error) => void
): Promise<T> => {
  try {
    const response = await apiCall();

    return response.data;
  } catch (error) {
    if (errorCallback) {
      errorCallback(error);
    } else {
      processUnexpectedError(error);
    }
  }
};
